<template>
  <div>
      <van-nav-bar title="抽奖记录" left-text="" left-arrow @click-left="onClickLeft()" />
      <div class="tips">
      *说明：热水壶、热熔机、天力文化衫、鳃型前置将在6月1日之后每周五进行快递发放，请及时填写收货地址并选择天力文化衫尺码，填写完成后请耐心等待发货！
      如有需要加急可联系所维护的业务人员。
    </div> 
      <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>操作</th>
            <th>序号</th>
            <th>奖品名称</th>
            <th>尺码</th>
            <th>是否核销</th>
            <th>兑奖码</th>
            <th>抽奖时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,idx) in drawList" v-bind:key="idx">
            <td v-if="item.WinningNum==3&&item.Size==null"><van-button type="primary" size="mini" @click="toSizeEdit(item.ID)">选择尺码</van-button></td>
            <td v-else>&nbsp;</td>
            <td>{{ idx+1 }}</td>
            <td>{{ item.PrizeName }}</td>
            <td>{{ item.Size }}</td>
            <td>{{ item.IsGrant==1?'是':'否' }}</td>
            <td>{{ item.WinningCode }}</td>
            <td>{{ item._CreateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>      
    <van-pagination
      mode="simple"
      v-model="currentPage"            
      :page-count="pageCount"
      :show-page-size="3"
      force-ellipses
      style="margin-top:10px;" @change="handleCurrentChange" />    
    </div>    
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, NavBar, Grid, GridItem, Tabs, Tab } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import { Pagination } from 'vant';

export default {
  name: "LuckDrawRecord",
  data() {
    return {      
      currentPage: 1,
      drawList: [],
      loading: false, 		// 是否处在加载状态
      finished: false, 		// 是否已加载完成
      total: 0,				    // 数据总条数
      pageCount: 0,       // 总页数
      pageSize: 0,    // 每页条数
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    
    GetData(){
      var that=this;
      if(that.isLogined){        
        that.$http.get("SDWorker/GetLuckyDrawRecord2024", {
              params: {
                period: 1,
                pageindex: that.currentPage,
                sort: '_CreateTime DESC',
              }
            }).then(res=>{
              for (let i = 0; i < res.data.ListData.length; i++) 
              {
                var record=res.data.ListData[i];
                if(record.IsGrant==1){
                  record.IsGrantDesc="是";
                }else{
                  record.IsGrantDesc="否";
                }
                switch (record.WinningNum) {
                  case 1:
                    record.PrizeName="28.8元红包一个";
                    break;
                  case 2:
                    record.PrizeName="品牌电热水壶一个";
                    break;
                  case 3:
                    record.PrizeName="天力文化衫一件";
                    break;
                  case 4:
                    record.PrizeName="数显热熔机一台";
                    break;
                  case 5:
                    record.PrizeName="价值1580元腮网前置一个";
                    break;
                  case 6:
                    record.PrizeName="2024元红包一个";
                    break;
                  default:
                    break;
                }
              }
              that.drawList=res.data.ListData;
              that.total = res.data.TotalCount;		// 给数据条数赋值
              that.loading = true;			// 加载状态结束 
              that.pageCount = res.data.PageCount;
              that.pageSize = res.data.PageSize;
              // 如果list长度大于等于总数据条数,数据全部加载完成
              if (that.drawList.length >= res.data.TotalCount) {
                  that.finished = true;		// 结束加载状态
              }
        });
      }
    },
    handleCurrentChange (page) {
      this.currentPage = page;
      this.GetData();
    },
    toSizeEdit(id) {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "SizeEdit",
        params: {drawId:id},
      });
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.GetData();
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [Pagination.name]:Pagination,
    [NavBar.name]:NavBar,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [Tabs.name]:Tabs,
    [Tab.name]:Tab
  },
};
</script>

<style scoped>
  .table_detail{
    overflow:auto;
    width: 100%;
    /* 固定滚动高度 */
    max-height: calc(100vh - 220px);
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
    border-right: 0;
    
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  td, th {
    border-right: 1px solid #EBEBEB;
    border-bottom :1px solid #EBEBEB;
    width:100px;
    height: 35px;
    color: #333;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 5px 5px 5px 0;
  }
  th {
    background: #FAFAFA;
    color: #999;
    font-weight: normal;
  }
  /* 固定首列*/
  td:first-child,
  th:first-child {
    width:100px;
    position:sticky;
    left:0;
    z-index:1;
    padding-left: 5px;
  }
  /* 固定表头*/
  thead tr th {
    position:sticky;
    top:0;
  }
  th:first-child{
    z-index:2;
  }
  /* 固定表头*/
  tfoot tr th {
    position:sticky;
    bottom:0;
    color: #333;
    font-weight: bold;
    border-bottom: 0;
  }
  th:first-child{
    z-index:2;
  }

</style>
